import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CuestionarioPregunta } from '../../_models/cuestionario-pregunta';
import { Cuestionario } from '../../_models/cuestionario';
import { CuestionarioPreguntaService } from '../../_services/cuestionario-pregunta.service';
import { BancoPreguntasService } from '../../_services/banco-preguntas.service';
import { Pregunta } from '../../_models/pregunta';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService } from 'primeng/api';

@Component( {
  selector: 'app-cuestionarios-pregunta-banco',
  templateUrl: 'cuestionarios-pregunta-banco.component.html'
} )

export class CuestionariosPreguntaBancoComponent implements OnInit {

  @Input() lisCuestionariosPreguntas: CuestionarioPregunta[] = [];
  @Input() cuestionario: Cuestionario;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  lisBancoPregunta: Pregunta[] = [];
  carInformacionInicial = true;
  guardando = false;
  submitted = false;
  columnas: any[] = [];
  preSeleccionadas: Pregunta[] = [];


  constructor( private cuePreguntaServicio: CuestionarioPreguntaService,
               private navServicio: NavService,
               private conServicio: ConfirmationService,
               private preBancoServicio: BancoPreguntasService ) {
  }


  ngOnInit(): void {
    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_PREGUNTA' ), sort: false },
      { field: 'tipoPregunta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_TIPO' ), sort: false }
    ];

    this.preBancoServicio.listado().subscribe( lisBancoPregunta => {
      const preguntas = [];
      lisBancoPregunta.map( ( s: Pregunta ) => {
        if ( s.indicadorHabilitado && !this.lisCuestionariosPreguntas.find( x => x.idPregunta === s.idPregunta ) ) {
          preguntas.push( s );
        }
      } );
      this.lisBancoPregunta = preguntas;
      this.carInformacionInicial = false;
    } );
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'pregunta-banco',
        accept: () => {
          this.dismiss.emit( 'NL' );
        },
        reject: () => {
        }
      } );
    } else {
      this.dismiss.emit( 'NL' );
    }
  }

  guardar() {
    this.submitted = true;
    if ( this.preSeleccionadas.length > 0 ) {
      this.guardando = true;
      const datos = [];
      this.preSeleccionadas.map( ( s: Pregunta, index ) => {
        const a: CuestionarioPregunta = {
          id: null,
          idCuestionarioPregunta: null,
          idCuestionario: this.cuestionario.idCuestionario,
          idPregunta: s.idPregunta,
          indicadorDescartante: false,
          orden: this.obtenerSiguiente() + index,
          indicadorHabilitado: false,
          auditoriaUsuario: null,
          auditoriaFecha: null,
          pregunta: null,
          tipoPregunta: null,
          codigoTipoPregunta: null,
          cuestionario: null,
          respuestas: []
        };
        datos.push( a );
      } );

      this.cuePreguntaServicio.bulk( datos ).subscribe( respuesta => {
        this.guardando = false;
        this.dismiss.emit( 'L' );
      } );
    }
  }

  obtenerSiguiente( ): number {
    let maximo = 0;
    this.lisCuestionariosPreguntas.map( ( s: CuestionarioPregunta ) => {
      if ( s.orden > maximo ) {
        maximo = s.orden;
      }
    } );
    return maximo + 1;
  }


}
